import { pathOr, difference, isEmpty } from 'rambda';
import { map } from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import { IDeaNumUser } from '../interfaces';

export const deaNumUsersAllSelected = ({
  deaNumUsers,
  selectedUserRoleKeys,
}: {
  deaNumUsers: IDeaNumUser[];
  selectedUserRoleKeys: string[];
}) =>
  pipe(
    deaNumUsers,
    map<IDeaNumUser, string>(pathOr('', 'key')),
    a => difference(a, selectedUserRoleKeys),
    isEmpty
  ) && !isEmpty(deaNumUsers);
